import React from "react";
import Panel from "components/Panel";

import { useWorkbookActivityEventsQuery } from "./gql/Query.generated";
import Loading from "components/Loading";
import PanelSection from "components/PanelSection";
import { formatTimestampShort } from "utils/format";
import moment from "moment";
import Avatar from "components/Avatar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faFilePlus,
  faPen,
  faTrash,
} from "@fortawesome/pro-solid-svg-icons";

const ActivityPanel = ({ workbookId }: { workbookId: string }) => {
  const { loading, error, data } = useWorkbookActivityEventsQuery({
    variables: { workbookId },
  });

  if (loading || error) {
    return <Loading error={!!error} />;
  }

  return (
    <Panel title="Activity">
      <PanelSection className="leading-7">
        {data.getWorkbookDetails.activity.length === 0 ? (
          <div>No activity found</div>
        ) : (
          data.getWorkbookDetails.activity.map((event) => {
            const icon = event.eventType.includes("workbook_created")
              ? faBook
              : event.eventType.includes("variant_created")
              ? faFilePlus
              : event.eventType.includes("updated")
              ? faPen
              : faTrash;
            return (
              <div key={event.id}>
                <FontAwesomeIcon
                  icon={icon}
                  className="text-[#302654] min-w-[18px]"
                />{" "}
                <span className="font-bold text-[#555555]">
                  {formatTimestampShort(moment.unix(event.createdAt))}
                </span>
                : {event.description}{" "}
                {event.user && (
                  <span>
                    {" "}
                    by{" "}
                    <Avatar
                      name={event.user.fullname}
                      avatarUrl={event.user.avatarUrl}
                    />
                  </span>
                )}
              </div>
            );
          })
        )}
      </PanelSection>
    </Panel>
  );
};

export default ActivityPanel;
